export function renderBuildFormatActionDateSourceDateTemplate({
  optionsExportedExport
}: {
  optionsExportedExport: string
}): string {
  return `${optionsExportedExport}function formatActionDate(value: unknown): string {
  if (typeof value !== 'string') return ''
  const date = new Date(value)
  if (Number.isNaN(date.getTime())) return ''

  return date.toLocaleDateString('en-US', {
    month: 'short',
    day: '2-digit',
    year: 'numeric',
    timeZone: 'UTC'
  })
}`
}
